export enum BooleanValue {
  Yes = 'yes',
  No = 'no',
}
